



















import { Vue, Component, VModel, PropSync, Emit, Prop } from 'vue-property-decorator';

import MediaManager from "../../logic/MediaManager";
import { FilesWithPreviewToUpload, SelectedFileWithPreviewToUpload } from "../../logic/filesToUpload";
import FilesListWithThumbnail from "./FilesListWithThumbnail.vue";
import UploadThumbnailModal from "./UploadThumbnailModal.vue";

@Component({
  components: {
    FilesListWithThumbnail,
    UploadThumbnailModal
  }
})
export default class UploadThumbnail extends Vue {
  @VModel() filesList!: FilesWithPreviewToUpload

  @PropSync('visible', { type: Boolean }) isModalOpen!: boolean

  @PropSync('mediaManager') manager!: MediaManager

  @Prop({ type: Boolean, default: false }) hideInSpoiler!: boolean

  @Emit()
  uploadFiles(files: FilesWithPreviewToUpload) {
    this.isModalOpen = false;

    return files
  }

  currentItem: SelectedFileWithPreviewToUpload | null = null

  setCurrentFile(item: SelectedFileWithPreviewToUpload) {
    this.currentItem = item

    this.isModalOpen = true
  }
}
